import { useState } from 'react';
import Button from './Button';

export default function ContactForm({ variant = "default" }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [status, setStatus] = useState(''); // Estado para mensajes de envío

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    const data = new FormData(form);

    try {
      const response = await fetch(form.action, {
        method: 'POST',
        body: data,
        headers: {
          'Accept': 'application/json'
        }
      });

      if (response.ok) {
        setStatus('success');
        form.reset();
      } else {
        setStatus('error');
      }
    } catch (error) {
      // console.error("Error de red o JS:", error);
      setStatus('error');
    }
  };

  return (
    <>
      <Button variant={variant} onClick={() => { setIsModalOpen(true); setStatus(''); }}>
        Contáctanos
      </Button>

      {isModalOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 px-4"
          onClick={() => { setIsModalOpen(false); setStatus(''); }}
        >
          <div
            className="bg-white p-6 rounded-lg shadow-xl max-w-md w-full m-4"
            onClick={(e) => e.stopPropagation()}
          >
            <h3 className="text-2xl font-bold mb-4 text-blue-900">Contáctanos</h3>

            <form
              action="https://formspree.io/f/xpwlwwoe"
              method="POST"
              onSubmit={handleSubmit}
              className="space-y-4"
            >
              <div>
                <label htmlFor="name" className="block text-sm font-medium text-blue-800">
                  Nombre
                </label>
                <input
                  type="text"
                  name="name"
                  id="name"
                  required
                  className="mt-1 block w-full rounded-md border border-gray-400 shadow-sm focus:border-blue-500 focus:ring-blue-500"
                />
              </div>

              <div>
                <label htmlFor="email" className="block text-sm font-medium text-blue-800">
                  Correo Electrónico
                </label>
                <input
                  type="email"
                  name="email"
                  id="email"
                  required
                  className="mt-1 block w-full rounded-md border border-gray-400 shadow-sm focus:border-blue-500 focus:ring-blue-500"
                />
              </div>

              <div>
                <label htmlFor="message" className="block text-sm font-medium text-blue-800">
                  Mensaje
                </label>
                <textarea
                  name="message"
                  id="message"
                  rows={4}
                  required
                  className="mt-1 block w-full rounded-md border border-gray-400 shadow-sm focus:border-blue-500 focus:ring-blue-500"
                />
              </div>

              {status === 'success' && (
                <p className="text-blue-600">¡Mensaje enviado con éxito!</p>
              )}
              {status === 'error' && (
                <p className="text-red-600">Hubo un error al enviar el mensaje. Por favor, intenta nuevamente.</p>
              )}

              <div className="flex gap-4">
                <Button
                  type="submit"
                  variant="default"
                  className="w-full bg-blue-900 hover:bg-blue-800"
                  disabled={status === 'success'} // Deshabilitar botón tras envío exitoso para evitar duplicados
                >
                  {status === 'success' ? 'Enviado' : 'Enviar Mensaje'}
                </Button>
                <Button
                  type="button"
                  variant="secondary"
                  onClick={() => { setIsModalOpen(false); setStatus(''); }} // Limpiar status al cerrar
                  className="w-full bg-transparent border border-current hover:bg-blue-50"
                >
                  Cerrar
                </Button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
}